module.exports = __webpack_public_path__ + "img/05_uk.1bc3139c.svg";